// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__-dSmO","loader":"MediumLoader_loader__QgIW8","spinner-c7wet2":"MediumLoader_spinner-c7wet2__L8tPG"};